import { Component, ChangeDetectionStrategy, Input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';

import { PressKitSection } from '@modules/content-api/adapter/press-kit.adapter';
import {
  ActionIcons,
  ButtonItem,
  ActionContainerComponent,
} from '@modules/ui/action-container/action-container.component';

import { ImageComponent } from '../../media/image/image.component';
import { LocalizedDatePipe } from '../../pipes/localized-date.pipe';
import { SectionDefaultsComponent } from '../section-defaults';

@Component({
  selector: 'mb-press-kit-section',
  templateUrl: './press-kit-section.component.html',
  styleUrls: ['./press-kit-section.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ImageComponent, RouterLink, ActionContainerComponent, LocalizedDatePipe, TranslatePipe],
})
export class PressKitSectionComponent extends SectionDefaultsComponent {
  public defaultActions: ButtonItem[] = [
    {
      icon: ActionIcons.SHARE,
      class: 'btn btn-plain d-none d-sm-inline-flex',
    },
    {
      icon: ActionIcons.DOWNLOAD,
      class: 'btn btn-plain d-none d-sm-inline-flex',
    },
    {
      icon: ActionIcons.BOOKMARK,
      class: 'btn btn-plain',
    },
  ];

  @Input() pressKitSection!: PressKitSection;
}
